import Client from '../AxiosClient';
const resource = '/private/rankings';

export default {
  // Tra cứu bảng tổng hợp xếp loại lao động
  async getRankingsReport(year, month, department_id) {
    try {
      const params = {
        department_id: department_id ?? "",
        year: year ?? null,
        month: month ?? -1
      }
      const response = await Client.get(`${resource}/search`, {params: params});
      console.log(resource)
      return response;
    } catch(error) {
      return {
        "status": "failed",
        "data": [],
        "message": error.message
      }
    }
  },
  // Tải file excel bảng tổng hợp xếp loại lao động.
  async downloadRankingsReport(year,month,department_id) {
    try {
      const params = {
        department_id: department_id ?? "",
        year: year ?? null,
        month: month ?? -1
      }
      const response = await Client.get(`${resource}/download`, {
        headers: {
        "Access-Control-Expose-Headers": "Content-Disposition"
        },
        responseType: 'blob',
        params: params
      });
      return response;
    } catch(error) {
      return {
        "status": "failed",
        "data": [],
        "message": error.message
      }
    }
  }
}